import {searchAllSalesAndReturnTransactionsReport} from "../../../serviceBroker/transationReportApiServiceBroker";
import React, {FC} from "react";
import {DailyTransactionTypeEnum, PageEnum, TransactionReportSearchParamsModel} from "../../../models";
import {ReportPage, ReportTransactionSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId} from "../../../utils";

export const ReportAllSalesAndReturnTransactions: FC = () => {
    const initialState: TransactionReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
        transactionType:DailyTransactionTypeEnum.SalesInvoice
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchAllSalesAndReturnTransactionsReport}
            searchHeader={getPageNameByPageId(PageEnum.ReportAllPOS)}
            SearchPanel={ReportTransactionSearchPanel}
            formId={PageEnum.ReportAllPOS}
        />
    );
};
